<ng-container>
    <section style="width: 100%" class="w-full pt-2 rounded-md entity bg-card">
        <div class="pt-2 sm:flex sm:flex-wrap sm:-mx-4 sm:px-10">
            <!-- Title -->
            <div class="px-4 sm:w-full md:w-1/7">
                <h2
                    class="pb-3 text-3xl font-extrabold leading-7 tracking-tight truncate md:text-4xl sm:leading-10"
                >
                    {{ entityData.name | transloco }}
                </h2>
            </div>
            <!-- Action Buttons -->
            <div
                class="px-4 md:w-1/7 actionButtons"
                [ngClass]="!override.isRTL ? 'ml-auto' : 'mr-auto'"
            >
                <mat-icon
                    class="ml-2 mr-2 text-green-500 cursor-pointer icon-size-7"
                    *ngIf="entityData?.isExport"
                    svgIcon="heroicons_outline:document-text"
                    accesskey="e"
                    matTooltip="{{ 'Export Excel' | transloco }}"
                    (click)="entityData.onExport()"
                ></mat-icon>
                <mat-icon
                    *ngIf="entityData?.add !== false"
                    class="ml-2 mr-2 cursor-pointer icon-size-7 main-color"
                    accesskey="n"
                    matPrefix
                    matTooltip="{{ 'Add new' | transloco }}"
                    [svgIcon]="'mat_outline:add_circle'"
                    (click) ="add()"
                    
                >
                </mat-icon>
            </div>
        </div>

        <div class="flex-wrap content-start place-content-center sm:px-10">
            <!-- <div class="row-start-1 ">
                <mat-form-field class="flex-auto w-full border-none col-12 gt-xs:pr-3">
                    <input matInput appearance="outline" [(ngModel)]="searchValue" (change)="entityData.onFilter(searchValue)" placeholder="{{'Search' |transloco}}">
                    <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'">
                    </mat-icon>
                </mat-form-field>
            </div> -->
            <div
                class="flex-wrap content-start overflow-auto place-content-center sm:px-10"
            >
                <div class="row-start-1">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    </section>
</ng-container>
